import React from 'react';
import {buildBICardList, ReportGroupsName} from '../utils/data';

const queryList = buildBICardList();
const QueryListDisplay = ({onClick: handleQueryClick, t}) => {
  return (
    <div className='flexContainer threeCol'>
      {queryList.map((card, cardIndex) => {
        return (
          <div key={cardIndex} className='paddingLg borderThin borderNeutral borderRadiusAllLg'>
            <div className='fontHdr2 fontAllCaps'>{t(ReportGroupsName[cardIndex])}</div>
            {card.map((cardItem) => {
              return (
                <div className='fontPrimaryColor cursorPointer' id={cardItem.key} key={cardItem.key} onClick={(e) => handleQueryClick(e, cardItem)}>
                  {cardItem.value}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default QueryListDisplay;
